// ====================================================================================================================
// 画面パス関連定義
//
// /main[/sub][/id][/mode][/query]
// ====================================================================================================================

const keyworkDefs = {
  main: {
    ROOT: '/',
    TOP: 'top',
    USER_INFO: 'user-info',
    PASSWORD: 'password',
    DAILY_OPERATION: 'daily-operation',
    ASSIGNMENT: 'assignment',
    WORK_CONTENT: 'work-content',
    WORK_REPORT: 'work-report',
    EXPENSE: 'expense',
    MONTHLY_OPERATION: 'monthly-operation',
    SHIFT_APPLICATION: 'shift-application',
    ATTENDANCE_REPORT: 'attendance-report',
    PAYSLIP: 'payslip',
    OUTSOURCER: 'outsourcer',
    NOTIFICATION: 'notification',
    HELP: 'help',
    ERROR: 'error',
  },
  sub: {
    WORKER: 'worker',
    WORKER_ASSIGNMENT: 'worker-assignment',
    WORKER_MANAGEMENT: 'worker-management',
    MATTER: 'matter',
    REIMBURSEMENT: 'reimbursement',
    DETAIL: 'detail',
    INVOICE: 'invoice',
  },
  mode: {
    EDIT: 'edit',
    VIEW: 'view',
  },
} as const;

/**
 * 画面識別子
 */
export type PageMainId = keyof typeof keyworkDefs.main;
/**
 * 画面パス (main)
 */
export type PageMain = (typeof keyworkDefs.main)[PageMainId];
/**
 * 画面パス定義 (main)
 */
const PageMainDef: Record<PageMainId, PageMain> = keyworkDefs.main;

/**
 * サブ画面識別子
 */
export type PageSubId = keyof typeof keyworkDefs.sub;
/**
 * 画面パス (sub)
 */
export type PageSub = (typeof keyworkDefs.sub)[PageSubId];
/**
 * 画面パス定義 (sub)
 */
const PageSubDef: Record<PageSubId, PageSub> = keyworkDefs.sub;

/**
 * モード識別子
 */
export type ModeId = keyof typeof keyworkDefs.mode;
/**
 * 画面モード (mode)
 */
export type PageParamMode = (typeof keyworkDefs.mode)[ModeId];
/**
 * 画面モード定義 (mode)
 */
const PageModeDef: Record<ModeId, PageParamMode> = keyworkDefs.mode;

/**
 * 画面キーワード定義
 */
export const pageKeywords: {
  main: Record<PageMainId, PageMain>;
  sub: Record<PageSubId, PageSub>;
  mode: Record<ModeId, PageParamMode>;
} = keyworkDefs;

// ================
// 画面
// ================
/**
 * 画面パス
 */
const pages = {
  ROOT: PageMainDef.ROOT,
  TOP: `${PageMainDef.ROOT}${PageMainDef.TOP}`,
  USER_INFO: `${PageMainDef.ROOT}${PageMainDef.USER_INFO}`,
  PASSWORD: `${PageMainDef.ROOT}${PageMainDef.PASSWORD}`,
  DAILY_OPERATION: `${PageMainDef.ROOT}${PageMainDef.DAILY_OPERATION}`,
  ASSIGNMENT_SE: `${PageMainDef.ROOT}${PageMainDef.ASSIGNMENT}`,
  ASSIGNMENT_OUTSOURCER: `${PageMainDef.ROOT}${PageMainDef.ASSIGNMENT}`,
  WORKER_ASSIGNMENT: `${PageMainDef.ROOT}${PageMainDef.OUTSOURCER}/${PageSubDef.WORKER_ASSIGNMENT}`,
  WORK_CONTENT: `${PageMainDef.ROOT}${PageMainDef.WORK_CONTENT}`,
  WORK_REPORT: `${PageMainDef.ROOT}${PageMainDef.WORK_REPORT}`,
  MATTER_EXPENSE: `${PageMainDef.ROOT}${PageMainDef.EXPENSE}/${PageSubDef.MATTER}`,
  MONTHLY_OPERATION: `${PageMainDef.ROOT}${PageMainDef.MONTHLY_OPERATION}`,
  SHIFT_APPLICATION: `${PageMainDef.ROOT}${PageMainDef.SHIFT_APPLICATION}`,
  ATTENDANCE_REPORT: `${PageMainDef.ROOT}${PageMainDef.ATTENDANCE_REPORT}`,
  EXPENSE_REIMBURSEMENT: `${PageMainDef.ROOT}${PageMainDef.EXPENSE}/${PageSubDef.REIMBURSEMENT}`,
  EXPENSE_DETAIL: `${PageMainDef.ROOT}${PageMainDef.EXPENSE}/${PageSubDef.DETAIL}`,
  PAYSLIP: `${PageMainDef.ROOT}${PageMainDef.PAYSLIP}`,
  INVOICE: `${PageMainDef.ROOT}${PageMainDef.OUTSOURCER}/${PageSubDef.INVOICE}`,
  WORKER: `${PageMainDef.ROOT}${PageMainDef.OUTSOURCER}/${PageSubDef.WORKER}`,
  WORKER_MANAGEMENT: `${PageMainDef.ROOT}${PageMainDef.OUTSOURCER}/${PageSubDef.WORKER_MANAGEMENT}`,
  NOTIFICATION: `${PageMainDef.ROOT}${PageMainDef.NOTIFICATION}`,
} as const;

/**
 * 画面識別子
 */
export type Pages = keyof typeof pages;
export const pagePaths = pages;

/**
 * 画面名
 */
export const pageNames: Record<Pages, string> = {
  ROOT: '',
  TOP: 'TOP',
  USER_INFO: '個人情報設定',
  PASSWORD: 'パスワード変更',
  DAILY_OPERATION: '日次業務',
  ASSIGNMENT_SE: '手配',
  ASSIGNMENT_OUTSOURCER: '受注',
  WORKER_ASSIGNMENT: 'メンバアサイン',
  WORK_CONTENT: '就業内容',
  WORK_REPORT: '作業報告書',
  MATTER_EXPENSE: '現場経費',
  MONTHLY_OPERATION: '月次申請',
  SHIFT_APPLICATION: 'シフト申請',
  ATTENDANCE_REPORT: '勤怠申請',
  EXPENSE_REIMBURSEMENT: '交通費・経費申請',
  EXPENSE_DETAIL: '経費詳細',
  PAYSLIP: '給与確認',
  INVOICE: '請求',
  WORKER_MANAGEMENT: 'メンバ管理',
  WORKER: 'メンバ',
  NOTIFICATION: 'お知らせ検索',
} as const;
